// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-39713a26]{min-height:100vh;height:100%}.header-footer[data-v-39713a26]{background-color:#fbfbfb;border-top-right-radius:inherit;border-top-left-radius:inherit;border-bottom:1px solid;border-color:inherit;padding:10px 24px;-webkit-box-align:center;-ms-flex-align:center;align-items:center}@media (max-width:576px){.webform-header .webform-logo[data-v-39713a26]{text-align:center!important;padding:20px 0}}", ""]);
// Exports
module.exports = exports;
